import type * as Types from '../../../../../types';

import type { DocumentNode } from 'graphql';
import * as Urql from '@web/api';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SilosQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SilosQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', silos: Array<{ __typename?: 'Silo', id: string, name: string }> } | null };


export const SilosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"silos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"silos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;

export function useSilosQuery(options?: Omit<Urql.UseQueryArgs<SilosQueryVariables>, 'query'>) {
  return Urql.useQuery<SilosQuery, SilosQueryVariables>({ query: SilosDocument, ...options });
};